let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jMBLi")).then(() => parcelRequire('7ZLoJ'));